// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MeditationIconBumbleInline = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 65 65"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<defs>
			<linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="MeditationIconBumbleInline_tsx__a">
				<stop stopColor="#439BBF" offset="0%" />
				<stop stopColor="#65A294" offset="100%" />
			</linearGradient>
			<path
				d="M15 7.824c-3.957 0-7.176 3.22-7.176 7.177 0 3.957 3.22 7.175 7.177 7.175 3.956 0 7.175-3.218 7.175-7.175S18.957 7.824 15 7.824m0 19.52c-6.807 0-12.345-5.537-12.345-12.342C2.655 8.195 8.193 2.656 15 2.656c6.806 0 12.343 5.539 12.343 12.346 0 6.805-5.537 12.342-12.343 12.342"
				id="MeditationIconBumbleInline_tsx__b"
			/>
		</defs>
		<g fill="none" fillRule="evenodd">
			<circle fill="url(#MeditationIconBumbleInline_tsx__a)" cx={32.5} cy={32.5} r={32.5} />
			<use fill="#FFF" xlinkHref="#MeditationIconBumbleInline_tsx__b" transform="translate(18 18)" />
		</g>
	</svg>
);
export default MeditationIconBumbleInline;
